module.exports = __webpack_public_path__ + "img/matts.ff599683.png";